module.exports = __webpack_public_path__ + "img/america-diamonds-hotel.004c8baa.jpg";